import { AllocationRule } from 'further-types/lp/allocations';
import Table, { Column as TableColumn } from 'further-ui/components/Table';
import { Column, Row } from 'further-ui/components/Layout';
import BasicSelect from 'further-ui/components/BasicSelect';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const StyledBox = styled(Box)(() => ({ width: '320px' }));

const StyledRow = styled(Row)(({ theme }) => ({
  paddingLeft: theme.spacing(theme.spacingSizes.sm),
}));

export type EqualisationsAllocationsTableProps<T extends { id: string }> = {
  columns: Array<TableColumn<T>>;
  rows: Array<T>;
  showAllocationRule?: boolean;
  allocationRule?: AllocationRule;
  allocationRuleOptions?: Array<{ value: AllocationRule; label: string }>;
  onChangeAllocationRule?: (value: AllocationRule) => void;
  isNotEditable?: boolean;
  checkboxes?: {
    isCheckedRow: (row: T, rowIndex: number) => boolean;
    isDisabledRow?: (row: T, rowIndex: number) => boolean;
    onRowCheckedToggle: (row: T, rowIndex: number) => void;
  };
};

const EqualisationsAllocationsTable = <T extends { id: string }>({
  columns,
  rows,
  checkboxes,
  showAllocationRule = true,
  allocationRule,
  allocationRuleOptions = [],
  onChangeAllocationRule,
  isNotEditable = false,
}: EqualisationsAllocationsTableProps<T>) => {
  return (
    <Column spacing="sm">
      {showAllocationRule && (
        <StyledRow fullWidth centered spacing="sm">
          <Typography
            variant="h6"
            color={isNotEditable ? 'grey.900' : 'grey.600'}
          >
            Allocation rule
          </Typography>
          <StyledBox>
            <BasicSelect
              size="small"
              fullWidth
              value={allocationRule}
              disabled={isNotEditable}
              options={allocationRuleOptions}
              onChange={(value) => {
                onChangeAllocationRule?.(value);
              }}
            />
          </StyledBox>
        </StyledRow>
      )}
      <Table checkboxes={checkboxes} borderless rows={rows} columns={columns} />
    </Column>
  );
};

export default EqualisationsAllocationsTable;
